import React from 'react';
import PropTypes from 'prop-types';
import HeaderNotificationList from './HeaderNotificationList';
import RowNotifications from './RowNotifications';
import { StyledNumNotifications, StyledTableWrapper } from './style';
import GifModule from '../GifModule';

const numNotifications = notificationlist => (
  <StyledNumNotifications>
    {`Tienes ${notificationlist.length} ${
      notificationlist.length === 1
        ? 'notificación pendiente'
        : 'notificaciones pendientes'
    }`}
  </StyledNumNotifications>
);

const NotificationList = ({ isWidget, notificationList, onDelete }) => {
  const notviewed = isWidget
    ? notificationList.filter(not => not.viewed === false)
    : notificationList;

  return notviewed && notviewed.length > 0 ? (
    <StyledTableWrapper isWidget={isWidget}>
      {!isWidget && <HeaderNotificationList />}
      {isWidget && numNotifications(notviewed)}
      {isWidget && <GifModule />}
      {notviewed.map((item, i) => (
        <RowNotifications
          key={`row-d-${i + 1}`}
          item={item}
          isWidget={isWidget}
          onDelete={idNotification => onDelete(idNotification)}
        />
      ))}
    </StyledTableWrapper>
  ) : null;
};

NotificationList.propTypes = {
  notificationList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      lastname: PropTypes.string,
      department: PropTypes.string,
      extension: PropTypes.number,
      phones: PropTypes.string,
      email: PropTypes.string
    })
  )
};

export default NotificationList;
